export default "__VITE_ASSET__C1pINz5o__"